import { useMemo } from 'react';
import { useWellnessCompletionRate } from '../../../hooks/analytics/useWellnessAnalytics';
import { AnalyticsCard } from '../shared/AnalyticsCard';
import { SkeletonLoader } from '../shared/SkeletonLoader';
import { CHART_CONFIG } from '../config';
import { lazy, Suspense } from 'react';
const WellnessFormCompletionTrendsChart = lazy(async () => ({
  default: (await import('./WellnessFormCompletionTrendsChart')).WellnessFormCompletionTrendsChart,
}));
import { WellnessFilter } from '@repo/shared/dtos/analytics/AnalyticsFilterDto';
import { calculateCompletionRate } from './wellnessUtils';

interface WellnessTrendsProps {
  filters: WellnessFilter;
}

export function WellnessTrends({ filters }: WellnessTrendsProps) {
  const { data: completionData, isLoading, isError, error } = useWellnessCompletionRate(filters);

  const trends = completionData?.monthly_trends || [];

  const exportData = useMemo(() => {
    if (!trends.length) return [];

    return trends.map((trend, index) => ({
      rank: index + 1,
      month: trend.month_year,
      completionRate:
        Math.round(calculateCompletionRate(trend.completed_sessions, trend.total_sessions) * 100) /
        100,
      totalSessions: trend.total_sessions,
      completedSessions: trend.completed_sessions,
    }));
  }, [trends]);

  if (isError) return null;
  const accent = CHART_CONFIG.WELLNESS_TRENDS_COLOR;
  return (
    <AnalyticsCard
      title="Form Completion Rate Trends"
      isLoading={isLoading}
      error={error}
      exportData={exportData}
      exportFileName="wellness-completion-trends"
      accent={accent}
    >
      <Suspense fallback={<SkeletonLoader variant="chart" height="h-[350px]" />}>
        <WellnessFormCompletionTrendsChart data={trends} height={350} />
      </Suspense>
    </AnalyticsCard>
  );
}
